<template>
  <div class="page-header">
          <amplify-authenticator username-alias="email">
            <amplify-sign-up
              slot="sign-up"
              username-alias="email"
              :form-fields.prop="formFields"
            ></amplify-sign-up>
          </amplify-authenticator>
  </div>
</template>

<script>
import { onAuthUIStateChange } from "@aws-amplify/ui-components";

export default {
  name: "Auth",
  props: ["dest"],
  created() {
    onAuthUIStateChange((authState) => {
      console.log(`AuthState: ${authState}.`);
      //console.log(`AuthData: ${JSON.stringify(authData)}.`);
      this.$store.dispatch(
        "session/onCongnitoAuthStateChange",
        authState === "signedin"
      );
    });
    console.log(`Logging in. Destination: ${JSON.stringify(this.dest)}.`);
  },
  computed: {
    isPlayerLoggedIn() {
      return (
        this.$store.state.session.isAuthenticated //&& this.$store.state.session.player != null
      );
    },
  },
  watch: {
    isPlayerLoggedIn(val) {
      if (val) {
        let route = this.dest && this.dest.path != "/login"
            ? { name: this.dest.name, params: this.dest.params, query: this.dest.query }
            : { name: "home" };
        this.$router.push(route);
      }
    },
  },
  data() {
    return {
      formFields: [
        {
          type: "name",
          label: "Name",
          placeholder: "Firstname Lastname",
          required: true,
        },
        {
          type: "email",
          label: "Email Address",
          placeholder: "Email",
          required: true,
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Password",
          required: true,
        },
      ],
    };
  },
};
</script>

<style scoped>
amplify-authenticator {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100vh;
}
.page-header {
  background-image: url('/assets/img/Velios_Background-Image_4-3.jpg');
}
</style>